<template>
  <v-row no-gutters align="center" justify="center" style="max-width: 1850px">
    <v-app-bar absolute dark color="transparent" tile elevation="0">
      <v-col
        cols="12"
        class="my-0 py-0"
        style="text-decoration: none !important"
      >
        <v-row no-gutters align="center" justify="center">
          <v-col cols="3" lg="4" class="ml-0">
            <v-row align="center" justify="center">
              <v-col class="px-0 pt-4">
                <v-row no-gutters align="center" justify="center">
                  <a
                    href="https://www.ramajudicial.gov.co/"
                    target="_blank"
                    title="Ir a La Rama Judicial"
                  >
                    <img
                      alt="Ir a la rama Judicial"
                      cover
                      src="@/assets/logo1.png"
                      width="120"
                    />
                  </a>
                </v-row>
              </v-col>

              <v-col cols="3" class="text-center">
                <v-btn
                  icon
                  href="https://www.convertic.gov.co/641/w3-channel.html"
                  target="_blank"
                  title="Obtener Software para Accesibilidad"
                  aria-label="Obtener Software para Accesibilidad"
                >
                  <v-icon size="30" color="#3c91a5" class="iconos"
                    >fas fa-eye</v-icon
                  >
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6" lg="4" class="text-center">
            <span class="font-weight-medium title bluetext--text"
              >{{ hoy }} de {{ meses[mes - 1] }} - {{ year }}</span
            >
            <h1
              :class="`${
                $vuetify.breakpoint.md ? 'headline font-weight-bold' : ''
              } mt-2 leading--text`"
            >
              CONSULTA DE PROCESOS
              <br />NACIONAL UNIFICADA
            </h1>
          </v-col>
          <v-col cols="3" lg="4">
            <v-row no-gutters align="center" justify="center">
              <v-col cols="3" class="text-center" v-if="!isAuth">
                  <!-- to="/login/menu-signin" -->
                <v-btn
                  icon
                  title="Iniciar sesión"
                  aria-label="Iniciar sesión"
                  to="/login/signin"
                >
                  <v-icon size="30" color="#3c91a5">fas fa-user-circle</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="3" class="text-center" v-else>
                <v-btn
                  icon
                  title="Cerrar sesión"
                  aria-label="Cerrar sesión"
                  to="/Procesos/Index"
                  @click="signout"
                >
                  <v-icon size="30" color="#3c91a5">fas fa-sign-out-alt</v-icon>
                </v-btn>

                <p class="black--text user-name mb-0">
                  <!-- {{ $store.state.auth.authUser.nombre }} -->
                  {{ getUserName }}
                </p>
              </v-col>

              <v-col class="px-0">
                <v-row no-gutters align="center" justify="center">
                  <a
                    href="https://id.presidencia.gov.co/Paginas/presidencia.aspx"
                    target="_blank"
                    title="Ir a la Presidencia de la República de Colombia"
                  >
                    <img
                      alt="Ir a la presidencia de la República de Colombia"
                      cover
                      src="@/assets/EscudoColombia.png"
                      width="120"
                    />
                  </a>
                </v-row>
              </v-col>
              <v-col cols="1" class="pr-10">
                <v-row align="end" justify="start" style="margin-top: 25px">
                  <ThemeDark title="Activar modo oscuro" />
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-app-bar>
  </v-row>
</template>

<script>
import ThemeDark from "@/components/ThemeDark";
import { mapGetters } from "vuex";

export default {
  components: { ThemeDark },
  computed: { ...mapGetters("auth", ["isAuth","getUserName"]) },
  data: () => ({
    meses: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    hoy: "",
    mes: "",
    year: "",
  }),
  methods: {
    signout() {
      this.$store.commit("auth/CLEAR_AUTH_USER");
    },
  },
  created() {
    var d = new Date();
    this.hoy = d.getDate();
    this.mes = d.getMonth() + 1;
    this.year = d.getFullYear();
  },
};
</script>

<style lang="scss" scoped>
.user-name {
  color: black;
  font-size: 0.8rem;
}
</style>